export const themeJson = {
    "themeName": "layered",
    "colorPalette": "light",
    "isPanelless": false,
    "backgroundImage": "",
    "backgroundOpacity": 1,
    "backgroundImageAttachment": "scroll",
    "backgroundImageFit": "cover",
    "cssVariables": {
        "--sjs-corner-radius": "0px",
        "--sjs-base-unit": "8px",
        "--sjs-shadow-small": "0px 0px 0px 1px rgba(0, 0, 0, 0.05),0px 8px 16px 0px rgba(0, 0, 0, 0.1),0px 2px 4px 0px rgba(0, 0, 0, 0.1)",
        "--sjs-shadow-inner": "inset 0px 0px 0px 1px rgba(0, 0, 0, 0.05),inset 0px 1px 4px 0px rgba(0, 0, 0, 0.1)",

        /* Без границ: делаем прозрачный цвет по умолчанию */
        "--sjs-border-default": "rgba(0, 0, 0, 0)",
        "--sjs-border-light": "rgba(0, 0, 0, 0)",

        /* Общий фон и цвета */
        "--sjs-general-backcolor": "rgba(255, 255, 255, 1)",
        "--sjs-general-backcolor-dark": "rgba(245, 245, 245, 1)",
        "--sjs-general-backcolor-dim-light": "#FFEED4",
        "--sjs-general-backcolor-dim-dark": "#FFEED4",
        "--sjs-general-forecolor": "rgba(34, 34, 34, 1)",
        "--sjs-general-forecolor-light": "rgba(34, 34, 34, 0.55)",
        "--sjs-general-dim-forecolor": "rgba(34, 34, 34, 1)",
        "--sjs-general-dim-forecolor-light": "rgba(34, 34, 34, 0.5)",

        /* Основной цвет (primary) и второстепенный (secondary) */
        "--sjs-primary-backcolor": "rgba(193, 17, 30, 1)", /* #C1111E */
        "--sjs-primary-backcolor-dark": "rgba(119, 1, 1, 1)", /* #770101 - чуть темнее */
        "--sjs-primary-backcolor-light": "rgba(193, 17, 30, 0.1)",
        "--sjs-primary-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.25)",

        /* Второстепенный цвет (можем взять синий) */
        "--sjs-secondary-backcolor": "rgba(2, 48, 72, 1)", /* #023048 */
        "--sjs-secondary-backcolor-light": "rgba(2, 48, 72, 0.1)",
        "--sjs-secondary-backcolor-semi-light": "rgba(2, 48, 72, 0.25)",
        "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",

        /* Прочие «особые» цвета (если нужно) */
        "--sjs-special-red": "rgba(229, 10, 62, 1)",
        "--sjs-special-red-light": "rgba(229, 10, 62, 0.1)",
        "--sjs-special-red-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-green": "rgba(25, 179, 148, 1)",
        "--sjs-special-green-light": "rgba(25, 179, 148, 0.1)",
        "--sjs-special-green-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-blue": "rgba(67, 127, 217, 1)",
        "--sjs-special-blue-light": "rgba(67, 127, 217, 0.1)",
        "--sjs-special-blue-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-yellow": "rgba(255, 152, 20, 1)",
        "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
        "--sjs-special-yellow-forecolor": "rgba(255, 255, 255, 1)",

        "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0)",
        "--sjs-shadow-medium": "0px 2px 6px 0px rgba(0, 0, 0, 0.1)",
        "--sjs-shadow-large": "0px 8px 16px 0px rgba(0, 0, 0, 0.1)",
        "--sjs-shadow-inner-reset": "inset 0px 0px 0px 0px rgba(0, 0, 0, 0)",
        "--sjs-border-inside": "rgba(0, 0, 0, 0.16)",

        /* Настройка шрифтов (Roboto для текста, Roboto Slab для заголовков) */
        /* Заголовки */
        "--sjs-article-font-xx-large-fontFamily": "'Roboto Slab', serif",
        "--sjs-article-font-xx-large-fontWeight": "700",
        "--sjs-article-font-xx-large-lineHeight": "64px",
        "--sjs-article-font-x-large-fontFamily": "'Roboto Slab', serif",
        "--sjs-article-font-x-large-fontWeight": "700",
        "--sjs-article-font-x-large-lineHeight": "56px",
        "--sjs-article-font-large-fontFamily": "'Roboto Slab', serif",
        "--sjs-article-font-large-fontWeight": "700",
        "--sjs-article-font-large-lineHeight": "40px",
        "--sjs-article-font-medium-fontFamily": "'Roboto Slab', serif",
        "--sjs-article-font-medium-fontWeight": "700",
        "--sjs-article-font-medium-lineHeight": "32px",

        /* Обычный текст: Roboto 20px */
        "--sjs-article-font-default-fontFamily": "'Roboto', sans-serif",
        "--sjs-article-font-default-fontWeight": "400",
        "--sjs-article-font-default-lineHeight": "28px",
        "--sjs-article-font-default-fontSize": "20px",

        /* Остальное оставляем из шаблона / корректируем при надобности */
        "--sjs-article-font-xx-large-textDecoration": "none",
        "--sjs-article-font-xx-large-fontStyle": "normal",
        "--sjs-article-font-xx-large-fontStretch": "normal",
        "--sjs-article-font-xx-large-letterSpacing": "0",
        "--sjs-article-font-xx-large-paragraphIndent": "0px",
        "--sjs-article-font-xx-large-textCase": "none",

        "--sjs-article-font-x-large-textDecoration": "none",
        "--sjs-article-font-x-large-fontStyle": "normal",
        "--sjs-article-font-x-large-fontStretch": "normal",
        "--sjs-article-font-x-large-letterSpacing": "0",
        "--sjs-article-font-x-large-paragraphIndent": "0px",
        "--sjs-article-font-x-large-textCase": "none",

        "--sjs-article-font-large-textDecoration": "none",
        "--sjs-article-font-large-fontStyle": "normal",
        "--sjs-article-font-large-fontStretch": "normal",
        "--sjs-article-font-large-letterSpacing": "0",
        "--sjs-article-font-large-paragraphIndent": "0px",
        "--sjs-article-font-large-textCase": "none",

        "--sjs-article-font-medium-textDecoration": "none",
        "--sjs-article-font-medium-fontStyle": "normal",
        "--sjs-article-font-medium-fontStretch": "normal",
        "--sjs-article-font-medium-letterSpacing": "0",
        "--sjs-article-font-medium-paragraphIndent": "0px",
        "--sjs-article-font-medium-textCase": "none",

        "--sjs-article-font-default-textDecoration": "none",
        "--sjs-article-font-default-fontStyle": "normal",
        "--sjs-article-font-default-fontStretch": "normal",
        "--sjs-article-font-default-letterSpacing": "0",
        "--sjs-article-font-default-paragraphIndent": "0px",
        "--sjs-article-font-default-textCase": "none",
    },
    "header": {
        "height": 56,
        "textAreaWidth": 502,
    },
    "headerView": "advanced",
};

